/* unplugin-vue-components disabled */import script from "./titleText.vue?vue&type=script&setup=true&lang=js"
export * from "./titleText.vue?vue&type=script&setup=true&lang=js"

import "./titleText.vue?vue&type=style&index=0&id=525645be&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-525645be"]])

export default __exports__